// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer20: FC<Offer20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.354 18c-.194 0-.382-.035-.562-.104-.18-.07-.348-.18-.5-.334l-5.854-5.875a1.422 1.422 0 0 1-.333-.502 1.565 1.565 0 0 1-.105-.56c0-.194.035-.379.104-.552.07-.174.18-.337.333-.49L9.59 2.431c.149-.148.314-.257.495-.327S10.453 2 10.646 2H16.5c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v5.854c0 .198-.035.386-.104.565-.07.179-.179.343-.327.491l-7.152 7.152c-.153.153-.32.264-.5.334S9.549 18 9.354 18Zm0-1.5L16.5 9.354V3.5h-5.854L3.5 10.646 9.354 16.5ZM14.5 6.75c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885a1.205 1.205 0 0 0-.885-.365c-.347 0-.642.122-.885.365a1.205 1.205 0 0 0-.365.885c0 .347.121.642.365.885.243.243.538.365.885.365Z" />
        </svg>
    );
};

export default Offer20;
